const { type } = require("jquery");

let purchaseFormCount = 1;
let sellerFormCount = 1;
let investorFormCount = 1;
let founderFormCount = 1;
let checkBoxCount = 0;

$(document).on('change', '.type_of_entity, .seller_type_of_entity', (e) => {
    let purchaserselectElement = e.target;
   
    let currentPurchaserSeller;
    let typeOfEntity;
    if (agreementType == 'SINGLETRANCESSA') {
        currentPurchaserSeller = purchaserselectElement.getAttribute('founder') != null ? purchaserselectElement.getAttribute('founder') : purchaserselectElement.getAttribute('investor');
       
        if(purchaserselectElement.getAttribute('founder'))
        {
            purchaseFormCount = founderFormCount;
        }else{
            purchaseFormCount = investorFormCount;
        }
        typeOfEntity = purchaserselectElement.value;
        console.log(currentPurchaserSeller);
        console.log(typeOfEntity);
    }
    else {
        currentPurchaserSeller = (purchaserselectElement.getAttribute('purchaser') != null) ? purchaserselectElement.getAttribute('purchaser') : purchaserselectElement.getAttribute('seller') != null ? purchaserselectElement.getAttribute('seller') : purchaserselectElement.getAttribute('shareholder');
        typeOfEntity = purchaserselectElement.value;
    }
    //console.log(currentPurchaserSeller.split('_')[0]);
    // if(agreementType == 'SINGLETRANCESSA' && purchaseFormCount == 1 && currentPurchaserSeller.split('_')[0] == 'investor')
    // {
    //     purchaseFormCount = 0;
    // }
    //alert(purchaseFormCount)
    
    let isInvestorOne = '';

    if(agreementType == 'SINGLETRANCESSA'){
        purchaseFormCount = investorFormCount;
    }

    if(currentPurchaserSeller == 'investor_1')
    {
      isInvestorOne = 'investor_1'
    }

    switch (typeOfEntity) {
        case 'individual':
            let individualFormHtml = purchaserIndividualForm(purchaseFormCount, currentPurchaserSeller,isInvestorOne);
            $('#' + currentPurchaserSeller).html(individualFormHtml);
            break;
        case 'company':
            let companyFormHtml = purchaserCompanyForm(purchaseFormCount, currentPurchaserSeller,isInvestorOne);
            // console.log(companyFormHtml);
            // console.log(currentPurchaserSeller);
            $('#' + currentPurchaserSeller).html(companyFormHtml);
            break;
        case 'llp':
            let llpFormHtml = purchaserLlpForm(purchaseFormCount, currentPurchaserSeller,isInvestorOne);
            $('#' + currentPurchaserSeller).html(llpFormHtml);
            break;
        case 'partnership_firm':
            let partnerShipHtml = purchaserPartnershipForm(purchaseFormCount, currentPurchaserSeller,isInvestorOne);
            $('#' + currentPurchaserSeller).html(partnerShipHtml);
            break;
        case 'huf':
            let hufHtml = purchaserHufForm(purchaseFormCount, currentPurchaserSeller,isInvestorOne);
            $('#' + currentPurchaserSeller).html(hufHtml);
            break;
        default:
            alert('Please select correct entity type');
            return;
    }
});




$('#add_purchaser, #add_seller, #add_shareholder, #add_investor, #add_founder').click((e) => {

    let purchaserOrSellerClass = e.target.getAttribute('class').split(' ');
    let sellerOrPurchaser = ''
    let sellerOrPuchaserCount = 1;


    if ($.inArray("add_purchaser", purchaserOrSellerClass) > -1) {
        purchaseFormCount += 1;
        sellerOrPurchaser = 'purchaser';
        sellerOrPuchaserCount = purchaseFormCount;
    }

    if ($.inArray("add_seller", purchaserOrSellerClass) > -1) {
        sellerFormCount += 1;
        sellerOrPurchaser = 'seller';
        sellerOrPuchaserCount = sellerFormCount;
    }

    if ($.inArray("add_shareholder", purchaserOrSellerClass) > -1) {
        sellerFormCount += 1;
        sellerOrPurchaser = 'shareholder';
        sellerOrPuchaserCount = sellerFormCount;
    }

    if ($.inArray("add_investor", purchaserOrSellerClass) > -1) {
        investorFormCount += 1;
        sellerOrPurchaser = 'investor';
        sellerOrPuchaserCount = investorFormCount;
        $('#add_details_of_investment').click();
        addDetailsOfInvestment(sellerOrPurchaser,sellerOrPuchaserCount)
        //console.log('in add investor');
    }

    if ($.inArray("add_founder", purchaserOrSellerClass) > -1) {
        founderFormCount += 1;
        sellerOrPurchaser = 'founder';
        sellerOrPuchaserCount = founderFormCount;
    }

    //console.log(sellerOrPurchaser);
    //console.log(sellerOrPuchaserCount);
  

    let typeOfEntity = `<div class="${sellerOrPurchaser}__${sellerOrPuchaserCount} ${sellerOrPurchaser}">`;
    typeOfEntity += `<div class="row ${sellerOrPurchaser}_entity_${sellerOrPuchaserCount}">`;
    if(sellerOrPurchaser == 'investor'){
        typeOfEntity += ` <div class="col-md-2"><p>${sellerOrPurchaser.toUpperCase()}</p></div>`;
    }
    else{
    typeOfEntity += ` <div class="col-md-2"><p>${sellerOrPurchaser.toUpperCase()} ${sellerOrPuchaserCount}</p></div>`;
    }
    typeOfEntity += '<div class="form-group col-md-3">';
    //typeOfEntity += '<label for="execution_date">Type of Entity</label>';
    typeOfEntity += `<select class="form-control type_of_entity" id="type_of_entity" required ${sellerOrPurchaser}="${sellerOrPurchaser}_${sellerOrPuchaserCount}">`;
    typeOfEntity += '<option value="">Type of Entity</option>';
    typeOfEntity += '<option value="individual">Individual</option>';
    typeOfEntity += '<option value="company">Company</option>';
    typeOfEntity += '<option value="llp">LLP</option>';
    typeOfEntity += '<option value="partnership_firm">Partnership firm</option>';
    typeOfEntity += '<option value="huf">HUF</option>';
    typeOfEntity += '</select>';
    typeOfEntity += '</div>';
    typeOfEntity += '</div>';
    typeOfEntity += `<div class="row ${sellerOrPurchaser}_details_${sellerOrPuchaserCount}" id="${sellerOrPurchaser}_${sellerOrPuchaserCount}">`;
    let columnWidth = 3;
    typeOfEntity += '<div class="col-md-3">';
    // typeOfEntity += ' <label for="name_of_individual">Name:</label>';
    if(sellerOrPurchaser == 'investor'){
        columnWidth = 2;
    typeOfEntity += `<input type="text" class="form-control name_of_individual main_${sellerOrPurchaser}_${sellerOrPuchaserCount}" onkeyup="showInvestorNameInTranche(this,'${sellerOrPurchaser}',${sellerOrPuchaserCount})" required name="${sellerOrPurchaser}[individual][${sellerOrPuchaserCount}][name_of_individual]" placeholder="Name of company">`;
    }
    else{
        typeOfEntity += `<input type="text" class="form-control name_of_individual" required name="${sellerOrPurchaser}[individual][${sellerOrPuchaserCount}][name_of_individual]" placeholder="Name of Individual">`;
    }

    typeOfEntity += ' </div>';
    typeOfEntity += '<div class="col-md-3">';
    // typeOfEntity += ' <label for="address_of_individual">Address:</label>';
    typeOfEntity += `<input type="text" class="form-control address_of_individual" required name="${sellerOrPurchaser}[individual][${sellerOrPuchaserCount}][address_of_individual]" placeholder="Address of individual">`;
    typeOfEntity += '</div>';
    typeOfEntity += `<div class="col-md-${columnWidth}">`;
    // typeOfEntity += '<label for="citizen_of_individual">Citizen:</label>';
    typeOfEntity += `<input type="text" class="form-control citizen_of_individual" required name="${sellerOrPurchaser}[individual][${sellerOrPuchaserCount}][citizen_of_individual]" placeholder="Citizen">`;
    typeOfEntity += '</div>';
    typeOfEntity += `<div class="col-md-${columnWidth}">`;
    // typeOfEntity += '<label for="age_of_individual">Age:</label>';
    typeOfEntity += `<input type="text" class="form-control age_of_individual" required name="${sellerOrPurchaser}[individual][${sellerOrPuchaserCount}][age_of_individual]" placeholder="Age">`;
    typeOfEntity += '</div>';
    if(sellerOrPurchaser == 'investor'){
    typeOfEntity += '<div class="col-md-2">';
    // typeOfEntity += '<label for="age_of_individual">Age:</label>';
    typeOfEntity += `<button type="button" investor_id="${sellerOrPuchaserCount}" class="btn btn-primary delete_${sellerOrPurchaser}" id="delete_${sellerOrPurchaser}">Delete</button>`;
    typeOfEntity += '</div>';
    }
    typeOfEntity += ' </div>'
    typeOfEntity += '</div>';
    typeOfEntity += '<p></p>'

    $(`.${sellerOrPurchaser}_details`).append(typeOfEntity)
})




const purchaserIndividualForm = (purchaseFormCount, currentPurchaserSeller,investor='') => {
    let splitCurrentPurchaserSeller = currentPurchaserSeller.split('_');
    let current_purchaser_box_length =  $('.'+splitCurrentPurchaserSeller[0]).length;
    
    let individualForm = '<div class="col-md-3">';
    //individualForm += `<label for="name_of_individual">Name:</label>`;
    if(investor == 'investor_1')
    {   
        purchaseFormCount = 0;
    }
    if(agreementType == 'SINGLETRANCESSA')
    {
        individualForm += `<input type="text" class="form-control name_of_individual main_${splitCurrentPurchaserSeller[0]}_${purchaseFormCount}" required name="${splitCurrentPurchaserSeller[0]}[individual][${splitCurrentPurchaserSeller[1]}][name_of_individual]" placeholder="Name of individual" onkeyup="showInvestorNameInTranche(this,'${splitCurrentPurchaserSeller[0]}',${purchaseFormCount})">`;
    }
    else{
        individualForm += `<input type="text" class="form-control name_of_individual" required name="${splitCurrentPurchaserSeller[0]}[individual][${splitCurrentPurchaserSeller[1]}][name_of_individual]" placeholder="Name of individual">`;
    }
    individualForm += '</div>';
    individualForm += '<div class="col-md-3">';
    //individualForm += '<label for="name_of_individual">Address:</label>';
    individualForm += `<input type="text" class="form-control address_of_individual" required name="${splitCurrentPurchaserSeller[0]}[individual][${splitCurrentPurchaserSeller[1]}][address_of_individual]" placeholder="Address of individual">`;
    individualForm += '</div>';
    individualForm += '<div class="col-md-3">';
    //individualForm += '<label for="name_of_individual">Citizen:</label>';
    individualForm += `<input type="text" class="form-control citizen_of_individual" required name="${splitCurrentPurchaserSeller[0]}[individual][${splitCurrentPurchaserSeller[1]}][citizen_of_individual]" placeholder="Citizen">`;
    individualForm += '</div>';
    individualForm += '<div class="col-md-3">';
    //individualForm += '<label for="age_of_individual">Age:</label>';
    individualForm += `<input type="text" class="form-control age_of_individual" required name="${splitCurrentPurchaserSeller[0]}[individual][${splitCurrentPurchaserSeller[1]}][age_of_individual]" placeholder="Age">`;
    individualForm += '</div>';
    if(splitCurrentPurchaserSeller[0] == 'investor' && current_purchaser_box_length > 1 && investor == ''){
        individualForm += '<div class="col-md-2">';
        // typeOfEntity += '<label for="age_of_individual">Age:</label>';
        individualForm += `<button type="button" investor_id="${purchaseFormCount}" class="btn btn-primary delete_${splitCurrentPurchaserSeller[0]}" id="delete_${purchaseFormCount}">Delete</button>`;
        individualForm += '</div>';
        }
    //   individualForm += '</div>';
    return individualForm;
}


const purchaserCompanyForm = (purchaseFormCount, currentPurchaserSeller,investor='') => {
    let splitCurrentPurchaserSeller = currentPurchaserSeller.split('_');
    let current_purchaser_box_length =  $('.'+splitCurrentPurchaserSeller[0]).length;
    let companyForm = '<div class="col-md-3">'; 
    //companyForm += '<label for="name_of_company">Name:</label>';
    if(investor == 'investor_1')
    {   
        purchaseFormCount = 0;
    }
    if(agreementType == 'SINGLETRANCESSA')
    {
        companyForm += `<input type="text" class="form-control name_of_company main_${splitCurrentPurchaserSeller[0]}_${purchaseFormCount}" required name="${splitCurrentPurchaserSeller[0]}[company][${splitCurrentPurchaserSeller[1]}][name_of_company]" placeholder="Name of company" onkeyup="showInvestorNameInTranche(this,'${splitCurrentPurchaserSeller[0]}',${purchaseFormCount})">`;
    }
    else{
        companyForm += `<input type="text" class="form-control name_of_company" required name="${splitCurrentPurchaserSeller[0]}[company][${splitCurrentPurchaserSeller[1]}][name_of_company]" placeholder="Name of company">`;
    }
    // alert('in company form');

   // companyForm += `<input type="text" class="form-control name_of_company" required name="${splitCurrentPurchaserSeller[0]}[company][${splitCurrentPurchaserSeller[1]}][name_of_company]" placeholder="Name of company">`;
    companyForm += '</div>';
    companyForm += '<div class="col-md-3">';
    //companyForm += '<label for="address_of_company">Address:</label>';
    companyForm += `<input type="text" class="form-control address_of_company" required name="${splitCurrentPurchaserSeller[0]}[company][${splitCurrentPurchaserSeller[1]}][address_of_company]" placeholder="Address of Company">`;
    companyForm += '</div>';
    companyForm += '<div class="col-md-3">';
    //companyForm += '<label for="cin_of_company">CIN:</label>';
    companyForm += `<input type="text" class="form-control cin_of_company" required name="${splitCurrentPurchaserSeller[0]}[company][${splitCurrentPurchaserSeller[1]}][cin_of_company]" placeholder="CIN of Company">`;
    companyForm += '</div>';
    if(splitCurrentPurchaserSeller[0] == 'investor' && current_purchaser_box_length > 1 && investor == ''){
        companyForm += '<div class="col-md-2">';
        companyForm += `<button type="button" investor_id="${purchaseFormCount}" class="btn btn-primary delete_${splitCurrentPurchaserSeller[0]}" id="delete_${purchaseFormCount}">Delete</button>`;
        companyForm += '</div>';
        }
    // companyForm += `<div class="form-group col-md-2 ">`;
    // companyForm += `<button type="button" class="btn btn-primary remove_details_of_investment_box" remove="details_of_investment">Remove</button>`;
    // companyForm += '</div>';

    return companyForm;

}

const purchaserLlpForm = (purchaseFormCount, currentPurchaserSeller,investor='') => {
    let splitCurrentPurchaserSeller = currentPurchaserSeller.split('_');
    let current_purchaser_box_length =  $('.'+splitCurrentPurchaserSeller[0]).length;
    let llpForm = '<div class="col-md-3">';
    //llpForm += '<label for="name_of_llp">Name:</label>';
    if(investor == 'investor_1')
    {   
        purchaseFormCount = 0;
    }
    if(agreementType == 'SINGLETRANCESSA')
    {
        llpForm += `<input type="text" class="form-control name_of_llp main_${splitCurrentPurchaserSeller[0]}_${purchaseFormCount}" required name="${splitCurrentPurchaserSeller[0]}[llp][${splitCurrentPurchaserSeller[1]}][name_of_llp]" placeholder="Name of LLP" onkeyup="showInvestorNameInTranche(this,'${splitCurrentPurchaserSeller[0]}',${purchaseFormCount})">`;
    }
    else{
        llpForm += `<input type="text" class="form-control name_of_llp" required name="${splitCurrentPurchaserSeller[0]}[llp][${splitCurrentPurchaserSeller[1]}][name_of_llp]" placeholder="Name of LLP">`;
    }
  //  llpForm += `<input type="text" class="form-control name_of_llp" required name="${splitCurrentPurchaserSeller[0]}[llp][${splitCurrentPurchaserSeller[1]}][name_of_llp]" placeholder="Name of LLP">`;
    llpForm += '</div>';
    llpForm += '<div class="col-md-3">';
    //llpForm += '<label for="address_of_llp">Registered office Address LLIP:</label>';
    llpForm += `<input type="text" class="form-control address_of_llp" required name="${splitCurrentPurchaserSeller[0]}[llp][${splitCurrentPurchaserSeller[1]}][address_of_llp]" placeholder="Address of LLP">`;
    llpForm += '</div>';
    llpForm += '<div class="col-md-3">';
    //llpForm += '<label for="cin_of_company">LLPIN:</label>';
    llpForm += `<input type="text" class="form-control llpin_of_company" required name="${splitCurrentPurchaserSeller[0]}[llp][${splitCurrentPurchaserSeller[1]}][llpin_of_company]" placeholder="LLPIN of Company">`;
    llpForm += '</div>';
    if(splitCurrentPurchaserSeller[0] == 'investor' && current_purchaser_box_length > 1 && investor == ''){
        llpForm += '<div class="col-md-2">';
        llpForm += `<button type="button" investor_id="${purchaseFormCount}" class="btn btn-primary delete_${splitCurrentPurchaserSeller[0]}" id="delete_${purchaseFormCount}">Delete</button>`;
        llpForm += '</div>';
        }

    return llpForm;
}

const purchaserPartnershipForm = (purchaseFormCount, currentPurchaserSeller,investor='') => {
    let splitCurrentPurchaserSeller = currentPurchaserSeller.split('_');
    let current_purchaser_box_length =  $('.'+splitCurrentPurchaserSeller[0]).length;
    let partnerShipForm = '<div class="col-md-3">';
    //partnerShipForm += '<label for="name_of_partnership_firm">Name:</label>';

    if(investor == 'investor_1')
    {   
        purchaseFormCount = 0;
    }

    if(agreementType == 'SINGLETRANCESSA')
    {
        partnerShipForm += `<input type="text" class="form-control name_of_partnership_firm main_${splitCurrentPurchaserSeller[0]}_${purchaseFormCount}" required name="${splitCurrentPurchaserSeller[0]}[partnership][${splitCurrentPurchaserSeller[1]}][name_of_partnership_firm]" placeholder="Name of Partnership" onkeyup="showInvestorNameInTranche(this,'${splitCurrentPurchaserSeller[0]}',${purchaseFormCount})">`;
    }
    else{
        partnerShipForm += `<input type="text" class="form-control name_of_partnership_firm" required name="${splitCurrentPurchaserSeller[0]}[partnership][${splitCurrentPurchaserSeller[1]}][name_of_partnership_firm]" placeholder="Name of Partnership">`;
    }
    //partnerShipForm += `<input type="text" class="form-control name_of_partnership_firm" required name="${splitCurrentPurchaserSeller[0]}[partnership][${splitCurrentPurchaserSeller[1]}][name_of_partnership_firm]" placeholder="Name of Partnership">`;
    partnerShipForm += '</div>';
    partnerShipForm += '<div class="col-md-3">';
    //partnerShipForm += '<label for="address_of_partnership_firm">Registered office Address :</label>';
    partnerShipForm += `<input type="text" class="form-control address_of_partnership_firm" required name="${splitCurrentPurchaserSeller[0]}[partnership][${splitCurrentPurchaserSeller[1]}][address_of_partnership_firm]" placeholder="Address">`;
    partnerShipForm += '</div>';
    partnerShipForm += '<div class="col-md-3">';
    //partnerShipForm += '<label for="registration_no_partnership_form">Registration No:</label>';
    partnerShipForm += `<input type="text" class="form-control registration_no_partnership_form" required name="${splitCurrentPurchaserSeller[0]}[partnership][${splitCurrentPurchaserSeller[1]}][registration_no_partnership_form]" placeholder="Registration No">`;
    partnerShipForm += '</div>';
    if(splitCurrentPurchaserSeller[0] == 'investor' && current_purchaser_box_length > 1 && investor == ''){
        partnerShipForm += '<div class="col-md-2">';
        partnerShipForm += `<button type="button" investor_id="${purchaseFormCount}" class="btn btn-primary delete_${splitCurrentPurchaserSeller[0]}" id="delete_${purchaseFormCount}">Delete</button>`;
        partnerShipForm += '</div>';
        }
    return partnerShipForm;
}

const purchaserHufForm = (purchaseFormCount, currentPurchaserSeller,investor='') => {
    let splitCurrentPurchaserSeller = currentPurchaserSeller.split('_');
    let current_purchaser_box_length =  $('.'+splitCurrentPurchaserSeller[0]).length;
    let hufForm = '<div class="col-md-3">';
    
    //hufForm += '<label for="name_of_huf">Name:</label>';
    if(investor == 'investor_1')
    {   
        purchaseFormCount = 0;
    }

    if(agreementType == 'SINGLETRANCESSA')
    {
    hufForm += `<input type="text" class="form-control name_of_huf main_${splitCurrentPurchaserSeller[0]}_${purchaseFormCount}" required name="${splitCurrentPurchaserSeller[0]}[huf][${splitCurrentPurchaserSeller[1]}][name_of_huf]" placeholder="Name of HUF" onkeyup="showInvestorNameInTranche(this,'${splitCurrentPurchaserSeller[0]}',${purchaseFormCount})">`;
    }
    else{
    hufForm += `<input type="text" class="form-control name_of_huf" required name="${splitCurrentPurchaserSeller[0]}[huf][${splitCurrentPurchaserSeller[1]}][name_of_huf]" placeholder="Name of HUF">`;
    }
   // hufForm += `<input type="text" class="form-control name_of_huf" required name="${splitCurrentPurchaserSeller[0]}[huf][${splitCurrentPurchaserSeller[1]}][name_of_huf]" placeholder="Name of HUF">`;
    hufForm += '</div>';
    hufForm += '<div class="col-md-3">';
    //hufForm += '<label for="address_of_huf">Registered office Address HUF:</label>';
    hufForm += `<input type="text" class="form-control address_of_huf" required name="${splitCurrentPurchaserSeller[0]}[huf][${splitCurrentPurchaserSeller[1]}][address_of_huf]" placeholder="Address of HUF">`;
    hufForm += '</div>';
    hufForm += '<div class="col-md-3">';
    //hufForm += '<label for="registration_no_partnership_form">Registration No:</label>';
    hufForm += `<input type="text" class="form-control registration_no_huf" required name="${splitCurrentPurchaserSeller[0]}[huf][${splitCurrentPurchaserSeller[1]}][registration_no_huf]" placeholder="Registration No">`;
    hufForm += '</div>';
    if(splitCurrentPurchaserSeller[0] == 'investor' && current_purchaser_box_length > 1 && investor == ''){
        hufForm += '<div class="col-md-2">';
        hufForm += `<button type="button" investor_id="${purchaseFormCount}" class="btn btn-primary delete_${splitCurrentPurchaserSeller[0]}" id="delete_${purchaseFormCount}">Delete</button>`;
        hufForm += '</div>';
        }
    return hufForm;
}

var detailsOfInvestmentCount = 1;
//$(document).on('click', '#add_details_of_investment', (e) => {
function addDetailsOfInvestment(sellerOrPurchaser,sellerOrPuchaserCount){
    console.log(sellerOrPurchaser);
    console.log(sellerOrPuchaserCount);
    let detailsOfInvestment = `<div class="form-group col-md-3 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestment += `<input type="text" class="form-control investor_name_1_${detailsOfInvestmentCount} tranche_${sellerOrPurchaser}_${sellerOrPuchaserCount}" required name="investor_name[trance_1][]" id="${sellerOrPurchaser}_${sellerOrPuchaserCount}" readonly oninput="$('#investor_name_2_${detailsOfInvestmentCount}').val($(this).val())"  placeholder="Investor Name">`;
        detailsOfInvestment += '</div>';
        detailsOfInvestment += `<div class="form-group col-md-3 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestment += `<input type="text" class="form-control investment_amount_1_${detailsOfInvestmentCount}" required name="investment_amount[trance_1][]" placeholder="Investment Amount">`;
        detailsOfInvestment += '</div>';
        detailsOfInvestment += `<div class="form-group col-md-2 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestment += `<select class="form-control" name="type_of_security[trance_1][]" onchange="$('#type_of_security_2_${detailsOfInvestmentCount}').val($(this).val())">`;
        detailsOfInvestment += '<option value="" disabled selected>Type of security</option>';
        detailsOfInvestment += '<option value="equity">Equity</option>';
        detailsOfInvestment += '<option value="ccps">CCPS</option>';
        detailsOfInvestment += '<option value="ocps">OCPS</option>';
        detailsOfInvestment += '</select>';
        detailsOfInvestment += '</div>';
        detailsOfInvestment += `<div class="form-group col-md-2 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestment += `<input type="text" class="form-control number_of_shares_1_${detailsOfInvestmentCount}" required name="number_of_shares[trance_1][]""  placeholder="Number of shares">`;
        detailsOfInvestment += '</div>';
        // detailsOfInvestment += `<div class="form-group col-md-2 details_of_investment_${detailsOfInvestmentCount}">`;
        // detailsOfInvestment += `<button type="button" class="btn btn-primary remove_details_of_investment_box" remove="details_of_investment_${detailsOfInvestmentCount}">Remove</button>`;
        // detailsOfInvestment += '</div>';

        let detailsOfInvestmentTwo = `<div class="form-group col-md-3 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestmentTwo += `<input type="text" class="form-control trance_2_input_field investor_name_2_${detailsOfInvestmentCount} tranche_${sellerOrPurchaser}_${sellerOrPuchaserCount}" readonly id="investor_name_2_${detailsOfInvestmentCount}"  name="investor_name[trance_2][]"  placeholder="Investor Name">`;
        detailsOfInvestmentTwo += '</div>';
        detailsOfInvestmentTwo += `<div class="form-group col-md-3 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestmentTwo += `<input type="text" class="form-control trance_2_input_field investment_amount_2_${detailsOfInvestmentCount}" id="investment_amount_2_${detailsOfInvestmentCount}"  name="investment_amount[trance_2][]" placeholder="Investment Amount">`;
        detailsOfInvestmentTwo += '</div>';
        detailsOfInvestmentTwo += `<div class="form-group col-md-2 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestmentTwo += `<select class="form-control trance_2_input_field type_of_security_2_${detailsOfInvestmentCount}" id="type_of_security_2_${detailsOfInvestmentCount}" name="type_of_security[trance_2][]>`;
        detailsOfInvestmentTwo += '<option value="" disabled selected>Type of security</option>';
        detailsOfInvestmentTwo += '<option value="equity">Equity</option>';
        detailsOfInvestmentTwo += '<option value="ccps">CCPS</option>';
        detailsOfInvestmentTwo += '<option value="ocps">OCPS</option>';
        detailsOfInvestmentTwo += '</select>';
        detailsOfInvestmentTwo += '</div>';
        detailsOfInvestmentTwo += `<div class="form-group col-md-2 details_of_investment_${detailsOfInvestmentCount}">`;
        detailsOfInvestmentTwo += `<input type="text" id="number_of_shares_2_${detailsOfInvestmentCount}" class="form-control trance_2_input_field number_of_shares_2_${detailsOfInvestmentCount}"  name="number_of_shares[trance_2][]"  placeholder="Number of shares">`;
        detailsOfInvestmentTwo += '</div>';
        // detailsOfInvestmentTwo += `<div class="form-group col-md-2 details_of_investment_${detailsOfInvestmentCount}">`;
        // detailsOfInvestmentTwo += `<button type="button" class="btn btn-primary remove_details_of_investment_box" remove="details_of_investment_${detailsOfInvestmentCount}">Remove</button>`;
        // detailsOfInvestmentTwo += '</div>';

        $('.details_of_investment_box').append(detailsOfInvestment);
        $('.details_of_investment_box_two').append(detailsOfInvestmentTwo);
        detailsOfInvestmentCount++;
    }
//});

$(document).on('click','.remove_details_of_investment_box',(e)=>{
    $('.'+e.target.getAttribute('remove')).remove();
})

$(document).on('change','#number_of_trance',(e)=>{
    let numberOfTrance = $('#number_of_trance').val();
    $('.trance_2_input_field').removeAttr("required");
    $('#trance_details_two').hide();
    if(numberOfTrance == 2)
    {
        $('#trance_details_two').show();
        $('.trance_2_input_field').attr("required","required");
    }
});

$(document).on('click','.delete_investor',(e)=>{
  
   let currentInvestorId = e.target.getAttribute("investor_id");
   //alert(currentInvestorId);
   $('.investor__'+currentInvestorId).remove();
   let tranceCount = currentInvestorId - 1;
  $('.details_of_investment_'+tranceCount).remove();
});

$('#number_of_trance').change(()=>{
    let numberOfTrance = $('#number_of_trance').val()
    
    $(".trance_2_input_field").removeAttr('required');
    if(numberOfTrance == 2)
    {
        $(".trance_2_input_field").prop('required',true);
    }
})

//alert('hello world');
// function showInvestorNameInTranche(e){
//     console.log();
// }

//$('#add_details_of_investment').on()
// $(document).on('change','.seller_type_of_entity',(e)=>{
//     let sellerselectElement = e.target;
//     let currentPurchaser = sellerselectElement.getAttribute('seller');
//     let typeOfEntity = sellerselectElement.value;
//     console.log(currentPurchaser);
//     console.log(typeOfEntity);
// })
            